"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var logger_1 = require("./logger");
function createLogger(namespace) {
    return new logger_1.Logger('skynet-store-utilities', namespace);
}
exports.createLogger = createLogger;
//# sourceMappingURL=logging.utilities.js.map